// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  axis: "ScenarioFanChart__axis",
  chart: "ScenarioFanChart__chart",
  endLabel: "ScenarioFanChart__endLabel",
  fan: "ScenarioFanChart__fan",
  keyItem: "ScenarioFanChart__keyItem",
  mobileKey: "ScenarioFanChart__mobileKey",
  paper: "ScenarioFanChart__paper",
  present: "ScenarioFanChart__present",
  spot: "ScenarioFanChart__spot",
  svg: "ScenarioFanChart__svg",
  title: "ScenarioFanChart__title",
  xLabel: "ScenarioFanChart__xLabel",
  yLabel: "ScenarioFanChart__yLabel",
};
